import { v4 as uuidv4 } from 'uuid';
import { uncapitalizeFirstLetter } from '@/utilities';
import Moving from '@/mixins/Moving';

export default class Packet {
  constructor({
    tasks,
    targetTeam,
    path,
    type,
  }) {
    this.id = uuidv4();
    this.type = type;
    this.tasks = tasks;
    this.targetTeam = targetTeam;
    this.skills = {};
    this.konvaNode = undefined;

    this.addSkill(new Moving(this, path));
  }

  get taskCount() {
    return this.tasks.length;
  }

  get currentCoord() {
    return this.skills.moving?.currentCoord[this.step];
  }

  get path() {
    return this.skills.moving.path;
  }

  get step() {
    return this.skills.moving.step;
  }

  get isArrived() {
    return this.skills.moving.isArrived;
  }

  addSkill(skillInstance) {
    this.skills[uncapitalizeFirstLetter(skillInstance.constructor.name)] = skillInstance;
  }

  setKonvaNode(node) {
    this.konvaNode = node;
  }

  move() {
    this.skills.moving.move();
  }

  arrive() {
    // 抵達：
    // 1. 從 packetList 移除：
    // 目前是 PathManager 在 ProcessByTick() 中自己檢查
    // 2. 通知 Team:
    // 應該要有個 Room 的角色，讓別人按門鈴
    // 再告知 Team 接收 Task
    this.targetTeam.receiveTask(this.tasks);
  }
}
